export const isAnyQueryLoading = (queries) => {
    return queries.some((query) => query.isLoading === true);
};
export const hasAnyQueryError = (queries) => {
    return queries.some((query) => query.hasError === true);
};
export const getFirstQueryError = (queries) => {
    const errorQuery = queries.find((query) => query.hasError === true);
    if (errorQuery && "error" in errorQuery) {
        return errorQuery.error;
    }
    return new Error("Unknown error in transition tasks");
};
export const hasAllRequiredData = (queries) => {
    return queries.every((query) => query.data !== undefined);
};
export const isDataDefined = (data) => {
    return data !== undefined;
};
export const createLoadingState = () => ({
    data: undefined,
    isLoading: true,
    hasError: false,
});
export const createErrorState = (error) => ({
    data: undefined,
    isLoading: false,
    hasError: true,
    error,
});
export const createSuccessState = (data) => ({
    data,
    isLoading: false,
    hasError: false,
});
//# sourceMappingURL=hookStateHelpers.js.map